/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FunctionComponent } from "react";

import { Spacing } from "@/tokens/spacing";
import { ColumnGaps } from "@/tokens/spacing";

import { GridColumn } from "@/ui/atoms/grid_column";
import { GridContainer } from "@/ui/atoms/grid_container";
import { Text } from "@/ui/atoms/text";
import {
    BlogArticleCard,
    BlogArticleSnippet,
} from "@/ui/organisms/blog_article_card";

import { useTypedTheme } from "@/util/hooks/theme_hooks";
import { buildStylesByBreakpoint } from "@/util/style_util";

interface RelatedBlogArticleCardListProps {
    Related_Articles: BlogArticleSnippet[];
}

export const RelatedBlogArticleCardList: FunctionComponent<
    RelatedBlogArticleCardListProps
> = (props) => {
    /**
     * Globals
     */
    const theme = useTypedTheme();

    /**
     * Styles
     */
    const containerStyles = css({
        display: "flex",
        flexDirection: "column",
        gap: Spacing["spacing-5"],
    });

    const subGridStyles = css(
        { display: "flex" },
        buildStylesByBreakpoint("flexDirection", {
            extraSmall: "column",
            medium: "row",
        }),
        buildStylesByBreakpoint("gap", ColumnGaps),
    );

    const cardWrapperStyles = css({
        flex: "1 1 0",
    });

    /**
     * Elements
     */
    return (
        <GridContainer
            className={containerStyles}
            /*
             * marginBottom="DefaultSectionMargin"
             * marginTop="TopicChipListMargin"
             */
        >
            <GridColumn>
                <Text color={theme.text.headlinePrimary} fontSize="TEXT_2">
                    Related
                </Text>
            </GridColumn>

            <GridColumn className={subGridStyles}>
                {props.Related_Articles.map((_article) => (
                    <div
                        css={cardWrapperStyles}
                        key={`related-articles::article-card::${_article.Slug}`}
                    >
                        <BlogArticleCard {..._article} />
                    </div>
                ))}
            </GridColumn>
        </GridContainer>
    );
};
